import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { PopupMenu } from "../../../internal/PopupMenu";
import { isProductionEnv, isTestEnv } from "../../../lib/currentEnvironment";
import { CommonWrapper } from "../../../internal/CommonWrapper";
/**
 * Меню, раскрывающееся по клику на переданный в ```caption``` элемент
 */

export var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.popupMenu = null;

    _this.open = function () {
      if (_this.popupMenu) {
        _this.popupMenu.open();
      }
    };

    _this.close = function () {
      if (_this.popupMenu) {
        _this.popupMenu.close();
      }
    };

    _this.refPopupMenu = function (ref) {
      return _this.popupMenu = ref;
    };

    _this.handleChangeMenuState = function (menuVisible) {
      if (menuVisible && _this.props.onOpen) {
        _this.props.onOpen();

        return;
      }

      if (!menuVisible && _this.props.onClose) {
        _this.props.onClose();

        return;
      }
    };

    if (!props.caption && !isProductionEnv) {
      throw new Error('Prop "caption" is required!!!');
    }

    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          popupMargin: '0px'
        }, theme)
      }, _this2.renderMain());
    });
  };

  _proto.renderMain = function renderMain() {
    if (!this.props.caption) {
      return null;
    }

    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement(PopupMenu, {
      ref: this.refPopupMenu,
      caption: this.props.caption,
      menuMaxHeight: this.props.menuMaxHeight,
      menuWidth: this.props.menuWidth,
      onChangeMenuState: this.handleChangeMenuState,
      popupHasPin: false,
      positions: this.props.positions,
      disableAnimations: this.props.disableAnimations,
      header: this.props.header,
      footer: this.props.footer,
      width: this.props.width
    }, this.props.children));
  };

  return DropdownMenu;
}(React.Component);
DropdownMenu.__KONTUR_REACT_UI__ = 'DropdownMenu';
DropdownMenu.defaultProps = {
  disableAnimations: isTestEnv,
  positions: ['bottom left', 'bottom right', 'top left', 'top right']
};